export default {
    methods: {
        reformatDate: function (str) {
            if ((str.split(".").length - 1) == 2){
                let date = moment(str,'DD.MM.YYYY')
                return date.format('YYYY-MM-DD')
            }
            if ((str.split("-").length - 1) == 2) {
                let date = moment(str,'YYYY-MM-DD')
                return date.format('DD.MM.YYYY')
            }
        },
        formatPrice: function (price) {
            return new Intl.NumberFormat('de-CH', {
                style: 'currency',
                currency: 'CHF',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(price);
        },
        getLargestAvailableImage: function(variants, aspectRatio = ''){
            if(aspectRatio) aspectRatio = '_'+aspectRatio;
            if(variants['img1900'+aspectRatio])return variants['img1900'+aspectRatio];
            if(variants['img1200'+aspectRatio])return variants['img1200'+aspectRatio];
            if(variants['img1000'+aspectRatio])return variants['img1000'+aspectRatio];
            if(variants['img800'+aspectRatio])return variants['img800'+aspectRatio];
            if(variants['img400'+aspectRatio])return variants['img400'+aspectRatio];
            return false;
        },
    },
    filters: {
        toCurrency: function (value) {
            if (isNaN(value)) {
                return '';
            }
            var formatter = new Intl.NumberFormat('de-ch', {
                style: 'currency',
                currency: 'CHF',
                minimumFractionDigits: 0
            });
            return formatter.format(value) + '.–';
        },
        toDateString: function (value) {
            return moment(value).locale('de').format('DD.MM.YY')
        },
        toDateStringShort: function (value) {
            return moment(value).locale('de').format('DD.MM.')
        },
        toDateStringComplete: function (value) {
            return moment(value).locale('de').format('DD.MM.YY HH:mm:ss')
        },
        toDateDay: function (value) {
            return moment(value).locale('de').format('dd')
        }
    }
};